import React from "react";
import styled from "styled-components";

const HeaderButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 36px;
    height: 36px;
    border-radius: 36px;
    
    :hover {
        background-color: #d8d8d8;
    }
`;

export default HeaderButton;